import React, { useEffect, useContext } from "react";
import { useHistory,useLocation } from "react-router-dom";
import useComponentWillMount from "../../components/hooks/useComponentWillMount";
import { BannerHalf, AppStoreBanner, Quicklinks } from "@dc/react-components";
import { appStoreBannerData } from "../../components/Content/AppStoreBannerData";
import homepageData from "../../components/Content/HomepageData";
import links from "../../components/Content/QuickLinksData";
import BannerTabs from "../../components/web/BannerTabs/BannerTabs";
import Tiles from "../../components/web/Tiles/Tiles";
import PopularTiles from "../../components/web/PopularTiles/PopularTiles";
import { mostPopularTilesData, discoverNewsTiles } from "../../components/Content/utilsCardsData";
import { setStartingPageData, trackView } from "@dc/utag-tracking";
import AppContext from "../../AppContext";
import BackgroundImage from "../../assets/images/kids-playing.png";

function Homepage() {
  useComponentWillMount(() => {
    window.scrollTo(0, 0);
  });

  const history = useHistory();
const search= useLocation();
const searchParams= new URLSearchParams(search)
  const { isLoggedIn } = useContext(AppContext);
  // TODO refactor for improved reusability
  const utagData = () => {
    return {
      event_name: "page_view",
      journey_type: "",
      page_channel: "MarTech Lab Web",
      page_country: "UK",
      page_domain: window.location.hostname,
      page_language: "EN",
      page_locale: window.navigator.language,
      page_name: "Home",
      page_section: "Home",
      page_type: "Landing page",
      page_url: window.location.href,
      visitor_auth_token: "1234567",
      visitor_login_status: isLoggedIn ? "logged in" : "logged out",
      visitor_type: isLoggedIn ? "customer" : "prospect"
    };
  };

  useEffect(() => {
    setStartingPageData(utagData());
    trackView();
  }, []);

  const { bannerHeadingText, logoFiles } = appStoreBannerData;
const changeparams=()=>{
  history.push('/?i_code=consumer-home-carousel_banner-switch_to_5g')
    trackView();
}
  return (
    <>
      <BannerHalf imageUrl={BackgroundImage} bannerHeading={bannerHeadingText} buttonText={homepageData.buttonText} buttonClick={changeparams} />
      <Quicklinks quickLinks={links} history={history} />
      <Tiles discoverTilesData={discoverNewsTiles} heading={homepageData.tilesHeading} />
      <PopularTiles tilesData={mostPopularTilesData} />
      <BannerTabs />
      <AppStoreBanner appStoreTitle={bannerHeadingText} appStoreLogos={logoFiles} />
    </>
  );
}

export default Homepage;
